<template>
  <div class="yk-source yk-source-new-wrapper-courseware"
       style="padding:0;">
    <div @click="videodialogVisible = true"
         class="upload-video-explain">（&nbsp;
      <i class="wl-icon-wanfashuoming"></i> 视频上传说明&nbsp;）</div>
    <div class="yk-batch-delete"
         style="top:15px;">
      <el-select class="change-search-in-wrapper"
                 filterable
                 v-model="sort"
                 placeholder="请选择排序方式"
                 style="margin-right: 10px; width: 150px;"
                 @change="restartSorting">
        <el-option v-for="item in sortOptions"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value">
        </el-option>
      </el-select>
      <el-button type="primary"
                 size="small"
                 @click="DelallCourseWare()">批量删除</el-button>
      <el-button type="primary"
                 icon="wl-icon-double-arrows"
                 size="small"
                 @click="move()">移动</el-button>
    </div>
    <el-tabs v-model="activeName"
             :tab-position="tabPosition"
             style="min-height: 200px;"
             @tab-click="onTabClickHandler"
             class="yl-last-source-tab-head-wrapper">
      <el-tab-pane v-for="(item, key) in source"
                   :key="key"
                   :label="item.label"
                   :name="item.name">
        <div v-if="item.name=='question'"
             class="yk-noQuestion">
          <img src="~assets/images/the-last-new-nodata-imag.png"
               alt=""
               class="yk-prompt">
          <span class="sp-noData">暂无上传数据.</span>
        </div>
        <div v-if="item.name=='test'"
             class="yk-noTest">
          <img src="~assets/images/the-last-new-nodata-imag.png"
               alt=""
               class="yk-prompt">
          <span class="sp-noData">暂无上传数据.</span>
        </div>
        <div v-if="item.name=='source'"
             class="yk-source-container clearfix">
          <el-breadcrumb separator="/"
                         style="padding: 14px;">
            <el-breadcrumb-item v-for="(li,key) in item.nodePathList"
                                :key="key">
              <span @click="clickFolderHander(li.Id)"
                    style="cursor: pointer;color:#000">{{li.nodeName}}</span>
            </el-breadcrumb-item>
          </el-breadcrumb>
          <div class="clearfix"
               style="padding-bottom:50px;">
            <el-card body-style="{ padding: '0px',width:'260px'}"
                     class="yk-course-ware-el-card"
                     style="border:2px dashed #000;"
                     @click.native="addCourseWare">
              <div class="lectures-wrapper lectures-wrapper-new-s-1-1">
                <el-dropdown @command="handleCommand"
                             trigger="click"
                             ref="addDropdown">
                  <span class="el-dropdown-link">
                    <i class="wl-icon-tianjia1"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="a">
                      <create-folder v-show="isShow_source"
                                     class="yk-class-button" 
                                     :courseId="courseId"
                                     :courseName="courseName"
                                     :folderId="folderId"
                                     @done="overSaveFolderHander"></create-folder>
                    </el-dropdown-item>
                    <el-dropdown-item command="b">
                      <aliyun-oss v-show="isShow_source"
                                  url="/api/design/osssign/getsign"
                                  class="yk-class-button"
                                  :ispartner="0"
                                  :courseId="courseId"
                                  :courseName="courseName"
                                  :folderId="folderId"
                                  :files="files"
                                  @done="onAllFilesUpload" />
                    </el-dropdown-item>

                    <el-dropdown-item command="d">
                      <Url-Upload-Source v-show="isShow_source"
                                         class="yk-class-button"
                                         :IsPartner=0
                                         :CourseId="courseId"
                                         :folderId="folderId"
                                         @done="overSaveFolderHander"></Url-Upload-Source>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <div class="add-c-title">新增</div>
              </div>
            </el-card>
            <el-card class="yk-course-ware-el-card"
                     v-for="(li, key) in item.list"
                     :key="key"
                     body-style="{ padding: '0px',width:'260px'}">
              <div class="yk-checkBox">
                <el-checkbox name="checkbox"
                             class="checkBoxState"
                             v-model="checkedList[li.Id]"
                             @change="handleSelectionChange(li.Id)"></el-checkbox>
              </div>
              <a :href="li.ADocPrviewUrl"
                 style="text-decoration: none;color: #000;"
                 target="_blank">
                <!-- <i v-if="li.CourseWareType==0"
                   class="wl-icon-lianjie"
                   style="font-size: 102px;text-align: center;display: block;"></i> -->
                  <div class="lianjie-image-center" v-if="li.CourseWareType==0">
                    <img src="~assets/images/lianjie-tianchong.png" class="lianjie-image">
                  </div>
              </a>

              <div v-if="li.CourseWareType==1">
                <span @click="previewImage(li.Id,li.DocUrl,li.DocExtension)"
                      v-if="li.DocExtension=='.jpg'||li.DocExtension=='.png'||li.DocExtension=='.jpeg'||li.DocExtension=='.ico'||li.DocExtension=='.hdr'||li.DocExtension=='.gif'">
                  <img v-show="li.DocUrl!=''"
                       :src="li.DocUrl"
                       class="image">
                  <img v-show="li.DocUrl==''"
                       :src="defaultCover"
                       class="image">
                  <i v-show="li.DocUrl==null"
                     class="wl-icon-jpg"></i>
                </span>
                <span @click="previewImage(li.Id,li.DocUrl,li.DocExtension)"
                      v-if="li.DocExtension=='.ziph'">
                  <img src="~assets/images/pic2.png"
                       class="image">
                </span>
                <span @click="previewImage(li.Id,li.DocUrl,li.DocExtension)"
                      v-if="li.DocExtension=='.mp4'">
                  <img v-show="li.DocUrl!=''"
                       :src="li.DocUrl+'?x-oss-process=video/snapshot,t_10000,f_jpg,w_329,h_160'"
                       class="image">
                  <img v-show="li.DocUrl==''"
                       :src="defaultCover"
                       class="image">
                  <i v-show="li.DocUrl==null"
                     class="wl-icon-mp1"></i>
                </span>

                <span @click="previewImage(li.Id,li.DocUrl,li.DocExtension)"
                      v-if="li.DocExtension=='.pdf'||li.DocExtension=='.txt'||li.DocExtension=='.ppt'||li.DocExtension=='.pptx'||li.DocExtension=='.doc'||li.DocExtension=='.docx'">
                  <img v-show="li.DocPrexUrl!=''"
                       :src="li.DocPrexUrl"
                       class="image">
                  <img v-show="li.DocPrexUrl==''"
                       :src="defaultCover"
                       class="image">
                  <i v-show="li.DocPrexUrl==null"
                     class="wl-icon-doc"></i>
                </span>
                <span @click="previewImage(li.Id,li.DocUrl,li.DocExtension)"
                      style="font-size:100px;display: block;text-align: center;background-color:#4eaf3e;color:white"
                      v-if="li.DocExtension=='.xlsx'||li.DocExtension=='.xls'">
                  <i class="wl-icon-xls"></i>
                </span>
                <span style="font-size:100px;display: block;text-align: center;background-color:#CA0C16;color:white"
                      @click="previewImage(li.Id,li.DocUrl,li.DocExtension)"
                      v-if="li.DocExtension=='.swf'">
                  <i class="wl-icon-flash image"></i>
                </span>
              </div>
              <span style="font-size:100px;display: block;text-align: center;background-color:#2A4DA0;color:white"
                    @click="previewImage(li.Id,li.DocUrl,li.DocExtension)"
                    v-if="li.DocExtension=='.mp3'">
                <i class="wl-icon-mp"></i>
              </span>
              <span style="font-size:100px;display: block;text-align: center;background-color:#9BCE5F;color:white"
                    @click="previewImage(li.Id,li.DocUrl,li.DocExtension)"
                    v-if="li.DocExtension=='.rar'||li.DocExtension=='.zip'||li.DocExtension=='.7z'">
                <i class="wl-icon-zip"></i>
              </span>
              <img v-if="li.CourseWareType==2"
                   src="~assets/images/last-new-folder.png"
                   class="image"
                   @click="clickFolderHander(li.Id)">
              <div class="yk-source-intro">
                <div class="yk-info-name"
                     :title="li.CourseWareName">{{ li.CourseWareName }}</div>
                <div class="yk-info-footer">
                  <div>{{li.CreateDisplayName}}</div>
                  <div class="yk-operate-btns">
                    <el-dropdown trigger="click"
                                 @command="onDropdownClickHandler"
                                 >
                      <el-button class="yk-course__control">
                        <i class="wl-icon-i-more"></i>
                      </el-button>
                      <el-dropdown-menu slot='dropdown'>
                        <el-dropdown-item :command="{type: 'edit', data: li}">
                          <span>重命名</span>
                        </el-dropdown-item>
                        <el-dropdown-item :command="{type: 'sort', data: li}">
                          <span>排序</span>
                        </el-dropdown-item>
                        <el-dropdown-item :command="{type: 'delete', data: li}">
                          <span>删除</span>
                        </el-dropdown-item>
                        <el-dropdown-item :command="{type: 'label', data: li}"
                                          v-if="li.CourseWareType != 2">
                          <span>标签</span>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                  <a class="wl-icon-xiazai xiazai"
                     v-if="li.CourseWareType==1"
                     :href="li.DownloadUrl" style="color:#000;"></a>
                </div>
              </div>
            </el-card>
          </div>
          <div v-if="noDataShow"
               class="yk-nodata-source-content"
               style="margin-top:-40px">
            <img src="~assets/images/the-last-new-nodata-imag.png"
                 alt=""
                 class="yk-prompt">
            <div class="sp-noData">暂无课件。 您可以点击大加号进行上传或者新建文件夹</div>
          </div>
          <loadingData v-if="loadingShow"></loadingData>
        </div>
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="onPageChangeHandler"
                       :current-page="item.pageIndex"
                       :page-sizes="[15, 31, 63]"
                       :page-size="item.pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="item.totalCount"
                       v-show="item.totalCount>0">
        </el-pagination>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="请选择路径"
               :visible.sync="rdialogVisible"
               width="30%"
               :append-to-body="true"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :before-close="handleCloseSource">
      <el-tree :data="nodeTree"
               :props="defaultProps"
                node-key="id"
               :default-expanded-keys="['0']"
               @node-click="handleNodeClick"
               class="foldertree"></el-tree>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="cancelMoveFolde">取 消</el-button>
        <el-button type="primary"
                   @click="MoveFolder()">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="请输入文件排序序号"
               :visible.sync="sortdialogVisible"
               width="20%"
               :append-to-body="true"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :before-close="handleCloseSourceSort">
      <el-input type="number"
                :min="min"
                v-model="sortNum"></el-input>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary"
                   @click="sortCourseware()">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="请重命名"
               :visible.sync="dialogVisible"
               width="450px"
               :append-to-body="true"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               center>
      <el-form label-width="80px">
        <el-form-item label="名称：">
          <el-input v-model="name"
                    placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="链接："
                      v-if="CourseWareType==0">
          <el-input v-model="txtsourceUrl"
                    placeholder="请输入链接"></el-input>
        </el-form-item>
        <el-form-item style="center">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary"
                     @click="update(SourceId,CourseWareType)">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="导入课件"
               :visible.sync="ThirePartydialogVisible"
               width="80%"
               :append-to-body="false"
               :close-on-click-modal="false"
               :close-on-press-escape="false">
      <!-- <ManagerShare :ids.sync="sourceids"
                    :courseId="courseId"
                    :activityIds="SourceIds"
                    :IsState.sync="IsState"
                    :CouIsChoice="isChoice"
                    v-if="ThirePartydialogVisible"
                    @tabClick="getTabMsg"
                    @dialogBtn="getMsg"
                    @dialogrPatnerBtn="getMsgPatner"></ManagerShare> -->
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="ThirePartydialogVisible = false">关闭</el-button>
        <el-button type="primary"
                   @click="importSource()"
                   v-show="btnShow">选择</el-button>
      </div>
    </el-dialog>

    <el-dialog title="视频上传说明"
               :visible.sync="videodialogVisible"
               width="40%"
                append-to-body>
      <div class="video_a"
           style="text-align: center;margin-bottom: 20px;">
        <span style="font-size:20px;color:red;">请将视频转换格式转换成mp4格式</span><br /><br />
        <a href="https://www.zhykt.com/api/design/CourseWare/downloadfile?fileKey=66ykt/ori/ee8gafmo-zjlo6yxz9qmta/H3m2Zki55D4bXkxd.rar&filename=FormatFactory_setup.rar"
           target="_blank"
           style="color:blue;text-decoration: underline;font-size:20px;">视频转码教程</a>
      </div>
      <div class="video-wrapper">
        <video-player class="video-player vjs-custom-skin"
                      ref="videoPlayer"
                      :playsinline="true"
                      :options="playerOptions"
                      v-if="videodialogVisible">
        </video-player>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="videodialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="添加标签"
               :visible.sync="dialogVisibleLabel"
               width="45%"
               :append-to-body="true"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               center>
      <el-form label-width="120px">
        <el-form-item label="关键字：">
          <el-select v-model="keyword"
                     multiple
                     filterable
                     allow-create
                     default-first-option
                     placeholder="请输入关键词 Enter键确认"
                     :loading="loading"
                     style="width:45%">
            <el-option v-for="item in options4"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="媒体类型：">
          <template>
            <el-select v-model="mediaType"
                       placeholder="媒体类型"
                       style="width:45%">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </template>
        </el-form-item>
        <el-form-item label="课件语言：">
          <template>
            <el-radio v-model="language"
                      label="1">中文</el-radio>
            <el-radio v-model="language"
                      label="2">英文</el-radio>
            <el-radio v-model="language"
                      label="3">中英双语</el-radio>
            <el-radio v-model="language"
                      label="4">其它</el-radio>
          </template>
        </el-form-item>
        <el-form-item label="课件来源：">
          <template>
            <el-radio v-model="sourceone"
                      label="1">原创</el-radio>
            <el-radio v-model="sourceone"
                      label="2">网络</el-radio>
            <el-radio v-model="sourceone"
                      label="3">教材</el-radio>
            <el-radio v-model="sourceone"
                      label="4">其它</el-radio>
            <el-radio v-model="sourceone"
                      label="5">不详</el-radio>
          </template>
        </el-form-item>
        <el-form-item label="作者："
                      v-show="sourceone==1">
          <el-input v-model="author"
                    placeholder="作者"></el-input>
        </el-form-item>
        <el-form-item label="所在单位："
                      v-show="sourceone==1">
          <el-input v-model="company"
                    placeholder="所在单位"></el-input>
        </el-form-item>
        <el-form-item label="联系方式："
                      v-show="sourceone==1">
          <el-input v-model="contactInformation"
                    placeholder="联系方式"></el-input>
        </el-form-item>
        <el-form-item style="center">
          <el-button @click="end()">取 消</el-button>
          <el-button type="primary"
                     @click="AddLabels()">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!--课件预览-->
    <div class="PreviewResourcces" v-show="dialogVisiblePreviewResources">
      <PreparingCourseware v-if="dialogVisiblePreviewResources"
                           :sourceId="this.sourceId"
                           :bottommenu="true"
                           :courseId="courseId"
                           :savesession="false"
                           @dialogVisiblePreviewResources="closeSource"
                           :fileList="this.fileList"></PreparingCourseware>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import AliyunOSS from "components/AliyunOSS.vue";
import CreateFoleder from "components/CreateFolder.vue";
import PreparingCourseware from "components/PreparingCourseware.vue";
import UrlUploadSource from "components/AliyunOSS/UrlUploadSource.vue";
// import ManagerShare from "components/ManagerShare.vue";
export default Vue.extend({
  components: {
    "aliyun-oss": AliyunOSS,
    "create-folder": CreateFoleder,
    "Url-Upload-Source": UrlUploadSource,
    // ManagerShare,
    PreparingCourseware,
  },
  data() {
    return {
      name:'',
      txtsourceUrl: "",
      files: [],
      tabNameList: ["source", "question", "test"],
      activeName: "source",
      loadingShow: false,
      noDataShow: false,
      source: [
        {
          label: "",
          pageSize: 15,
          pageIndex: 0,
          totalCount: 0,
          name: "source",
          list: [],
          nodePathList: []
        }
      ],
      tabPosition: "top",
      isShow_source: true,
      courseName: "22",
      newFolderId: "",
      previewShow: false,
      dataCount: 1,
      firstcome: true,
      sourceUrl: {
        id: "",
        url: "",
        type: "",
        docName: "",
        docType: 0
      },
      dialogVisible: false,
      FolderId: "",
      Id: "",
      courseWare: {
        Id: "",
        CourseWareName: ""
      },
      beforeDate: {
        beforeName: "",
        isReturn: true
      },
      menuShow: false,
      checked: false,
      ids: [],
      deleteList: [],
      dataList: [],
      checkedList: [],
      fId: "",
      rdialogVisible: false,
      pathdata: [{ label: "", id: "" }],
      defaultProps: {
        children: "children",
        label: "label"
      },
      nodeTree: [],
      sourceId: "",
      SourceId: "",
      docextension: "",
      newCourseId: this.$route.params.courseId,
      CourseWareType: 0,
      defaultCover: require("assets/images/noCover.jpg"), // 默认封面
      myid: "",
      otherid: "",
      ThirePartydialogVisible: false,
      SourceIds: [],
      list: [],
      IsState: 0,
      videodialogVisible: false,
      playerOptions: {
        autoplay: true,
        // preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:8", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4",
            src:"https://file.clpp.org.cn/66ykt/ori/2tv3anmogrronofrjgafcw/ktT7n7tMrbnchjbA.mp4"
            // "http://61.190.114.29/vhot2.qqvideo.tc.qq.com/A7WK5LbzqqFS5UPTih0y5hK5X-rPfmpNTm6Cd6mfq9eU/u0782kfelu4.p701.1.mp4?sdtfrom=v1105&guid=88830f01f33fb650e68b9324207638cf&vkey=B0B185D386B826E11B0F97210918C4A5674D41AEF430DCE63B3339C856FEEB831DCCE2DEE6794291ED1460E802905873B9D4BDD2FBF3BEAD9FC21AD0FE33EC01E42566FA0BE97C51E8BF138B1BC32FBF81836D404F8FD49ABA9BDB9235D6D862D81C3FEE3E6E760F925CDF5EA36FAC3F5C3E198348B1F064"//你的视频地址（必填）
          }
        ],
        poster:"https://file.clpp.org.cn/66ykt/ori/2tv3anmogrronofrjgafcw/W7GM6RQCh8GwP2EF.jpg",
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      },
      videourl:
        "https://www.bilibili.com/video/av31263333?from=search&seid=13775199045826412210",
      url_: "",
      //标签
      options4: [],
      loading: false,
      keyword: [],
      mediaType: 3,
      options: [
        {
          value: 1,
          label: "音频"
        },
        {
          value: 2,
          label: "视频"
        },
        {
          value: 3,
          label: "文档"
        },
        {
          value: 4,
          label: "ppt演示文稿"
        },
        {
          value: 5,
          label: "压缩包"
        },
        {
          value: 6,
          label: "网页课件"
        },
        {
          value: 7,
          label: "图形/图像类"
        },
        {
          value: 8,
          label: "动画"
        },
        {
          value: 9,
          label: "链接"
        }
      ],
      language: "1",
      sourceone: "1",
      author: "",
      company: "",
      contactInformation: "",
      dialogVisibleLabel: false,
      dialogVisiblePreviewResources: false,
      sourceids: [],
      isChoice: "",
      btnShow: false,
      tabClick: true,
      managerSchool: false,
      managerPatner: false,
      fileList: [],
      //排序
      sortOptions: [
        {
          value: "-CourseWareType+-DateCreated",
          label: "默认排序"
        },
        {
          value: "DateCreated",
          label: "时间正序"
        },
        {
          value: "-DateCreated",
          label: "时间倒序"
        },
        {
          value: "OrderNumber",
          label: "序号正序"
        },
        {
          value: "-OrderNumber",
          label: "序号倒序"
        }
      ],
      sort: "-CourseWareType+-DateCreated",
      sortNum: 0,
      sortId: "",
      sortdialogVisible: false,
      min: 0
    };
  },
  props: {
    courseId: {
      type: String,
      default: ""
    },
    folderId: {
      type: String,
      default: "0"
    }
  },
  watch: {
    IsState() {
      this.ThirePartydialogVisible = false;
      this.getSourceList(1, "source", 0);
    },
    courseId() {
      // this.getSourceList();
    },
    folderId(val) {
      this.getSourceList(1, "source", 0);
    }
  },
  created() {
    this.getSourceList(
      1,
      this.activeName,
      this.tabNameList.indexOf(this.activeName)
    );
  },
  methods: {
    // 更改排序方式
    restartSorting() {
      // this.source[0].pageIndex=1;
        this.getSourceList(
       
        this.source[0].pageIndex,
        this.activeName,
        this.tabNameList.indexOf(this.activeName)
      );
    },
    // 给课件添加排序
    sortCourseware() {
      var that = this;
      this.$http
        .post("/api/XOrg/BookMaterial/sortCourseware", {
          id: this.sortId,
          sortNum: this.sortNum
        })
        .then(function(rst) {
          if (rst.code > 0) {
            that.$message.success(rst.msg);
            that.getSourceList(
              that.source[0].pageIndex,
              that.activeName,
              that.tabNameList.indexOf(that.activeName)
            );
            that.cancel();
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    cancel() {
      this.sortdialogVisible = false;
      this.sortNum = 0;
      this.sortId = "";
    },
    // 切换本校、第三方显示隐藏按钮返回函数
    getTabMsg(val) {
      if (val == "0" && this.managerSchool == false) {
        this.btnShow = false;
      } else if (val == "1" && this.managerPatner == false) {
        this.btnShow = false;
      } else {
        this.btnShow = true;
      }
    },
    // 点击本校课程显示隐藏按钮返回函数
    getMsg(val) {
      if (val == true) {
        this.btnShow = true;
        this.managerSchool = true;
      } else {
        this.btnShow = false;
        this.managerSchool = false;
      }
    },
    // 点击外校课程显示隐藏按钮返回函数
    getMsgPatner(val) {
      if (val == true) {
        this.btnShow = true;
        this.managerPatner = true;
      } else {
        this.btnShow = false;
        this.managerPatner = false;
      }
    },
    closeSource() {
      this.dialogVisiblePreviewResources = false;
    },
    backtoclass() {
      this.$router.push({
        name: "ClassNew",
        params: {
          courseId: this.courseId
        }
      });
    },
    GetSourceShow: function() {
      this.$http.post('/api/XOrg/BookMaterial/GetTeacherIsAuthentication',{})
        .then( rst => {
          this.ThirePartydialogVisible = true;
        })
    },
    addCourseWare() {
      this.$refs.addDropdown[0].handleClick();
    },
    handleCommand(command) {},
    dialogClose() {
      this.dialogVisiblePreviewResources = false;
    },
    onAllFilesUpload() {
      this.source[0].pageIndex = 1;
      this.getSourceList(1, "source", 0);
    },
    // 获取课件列表
    getSourceList(idx, type, tabIndex) {
      this.$http.post('/api/XOrg/BookMaterial/getsourcelist',{
        courseId: this.courseId,
        folderId: this.folderId,
        type: type,
        sort: this.sort,
        page: idx,
        pageSiz: this.source[tabIndex].pageSize
      }).then( rst => {
        this.source[tabIndex].list = rst.list;
        this.loadingShow = false;
        if (rst.list.length == 0) {
          this.noDataShow = true;
        } else {
          this.noDataShow = false;
        }
        this.source[tabIndex].totalCount = rst.pagination.totalCount;
        this.source[tabIndex].pageSize = rst.pagination.pageSize;
        this.courseName = rst.courseName;
        this.source[tabIndex].nodePathList = rst.nodePathList;
        this.dataCount = rst.dataCount;
        this.myid = rst.myid;
        this.otherid = rst.otherid;
        this.fileList=[];
        rst.list.forEach(item => {
          if (item.CourseWareType == "1") {
            this.fileList.push(item.Id);
          }
          this.$set(this.checkedList, item.Id, false);
        });
        this.SourceIds = rst.list.map((ele) => {
          return ele.Id;
        });
      })
    },
    // 跳转第几页
    onPageChangeHandler(idx) {
      this.source[0].pageIndex = idx;
      this.getSourceList(
        idx,
        this.activeName,
        this.tabNameList.indexOf(this.activeName)
      );
    },
    // 一页显示多少条
    handleSizeChange(val) {
      this.source[0].pageSize = val;
      this.source[0].pageIndex = 1;
      this.getSourceList(
        this.source[0].pageIndex,
        this.activeName,
        this.tabNameList.indexOf(this.activeName)
      );
    },
    onTabClickHandler(tab) {
      let pageIndex = this.source[0].pageIndex;
      this.getSourceList(pageIndex, tab.name, tab.index);
      if (this.activeName == "source") {
        this.isShow_source = true;
      } else {
        this.isShow_source = false;
      }
    },
    overSaveFolderHander() {
      this.source[0].pageIndex = 1;
      this.getSourceList(1, "source", 0);
    },
    clickFolderHander(newFolderId) {
      this.$router.push({
        name: "teaShareManagementSource",
        params: { courseId: this.courseId, folderId: newFolderId }
      });
    },
    test: function() {
      this.$emit("test"); //把a标签的点击事件分发
    },
    previewImage(Id, url, type) {
      if (type == ".zip" || type == ".rar" || type == "7z") {
        this.$message("压缩包不支持预览");
      } else {
        if (type != "") {
          this.sourceId = Id;

          this.dialogVisiblePreviewResources = true;
        }
      }
    },
    previewElseSource() {},
    closePreview: function() {
      this.previewShow = false;
    },

    // 修改
    updateCourse() {
      if (this.name == "") {
        this.$message.warning("课件名称不可为空!");
        return false;
      }
      if (this.CourseWareType == 1) {
        var docname = this.name + "." + this.docextension;
      } else {
        var docname = this.name;
      }
      this.$http.post('/api/XOrg/BookMaterial/updateCourseWare',{
        id: this.SourceId,
        courseWareName: docname,
        txtsourceUrl: this.txtsourceUrl
      }).then( rst => {
        if (rst.code == 1) {
          this.getSourceList(this.source[0].pageIndex, "source", 0);
          this.dialogVisible = false;
          this.beforeDate.isReturn = false;
        } else {
          this.$message.warning(rst.msg);
        }
      })
    },
    update(Id, CourseWareType) {
      this.updateCourse();
    },
    onDropdownClickHandler(cos) {
      switch (cos.type) {
        case "edit":
          if (cos.data.CourseWareType == 1) {
            var str = cos.data.CourseWareName;
            this.name = str.substring(0, str.lastIndexOf("."));
            this.docextension = str.substring(
              str.lastIndexOf(".") + 1,
              str.length
            );

            this.SourceId = cos.data.Id;
            this.dialogVisible = true;
            this.CourseWareType = cos.data.CourseWareType;
          } else {
            var url = cos.data.ADocPrviewUrl;
            this.txtsourceUrl = url;
            this.name = cos.data.CourseWareName;
            this.SourceId = cos.data.Id;
            this.dialogVisible = true;
            this.CourseWareType = cos.data.CourseWareType;
          }
          break;
        case "sort":
          this.sortdialogVisible = true;
          this.sortNum = cos.data.OrderNumber;
          this.sortId = cos.data.Id;
          break;
        case "delete":
          this.isType = cos.data.CourseWareType;
          this.courseWare.Id = cos.data.Id;
          this.deletecourse(cos.data.Id);
          break;
        case "label":
          this.sourceId = cos.data.Id;
          if (cos.data.Keyword[0] == "") {
            this.keyword = [];
          } else {
            this.keyword = cos.data.Keyword;
          }

          if (cos.data.MediaType == 0) {
            this.mediaType = this.GetMediaType(cos.data.DocExtension);
          } else {
            this.mediaType = cos.data.MediaType;
          }

          if (cos.data.Language == "" || cos.data.Language == 0) {
            this.language = "1";
          } else {
            this.language = cos.data.Language;
          }

          if (cos.data.Source == "" || cos.data.Source == 0) {
            this.sourceone = "5";
          } else {
            this.sourceone = cos.data.Source;
          }

          this.author = cos.data.Author;
          this.company = cos.data.Company;
          this.contactInformation = cos.data.ContactInformation;
          this.dialogVisibleLabel = true;
          break;
        default:
          break;
      }
    },
    end() {
      this.sourceId = "";
      this.keyword = [];
      this.mediaType = 3;
      this.language = "1";
      this.sourceone = "1";
      this.author = "";
      this.company = "";
      this.contactInformation = "";
      this.dialogVisibleLabel = false;
    },

    // 删除
    delCourseWare(Id) {
      let self = this;
      let name = this.isType == "1" ? "课件" : "文件夹";
      this.$confirm("此操作将删除该" + name + ", 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
           let pageIndex = this.source[0].pageIndex;
            if(self.source[0].list.length == 1){
              this.source[0].pageIndex =this.source[0].pageIndex - 1;
            }
            this.$http.post('/api/XOrg/BookMaterial/delCourseWare',{
              id: Id
            }).then(rst => {
              if (rst.code == 1) {
                this.getSourceList(this.source[0].pageIndex, "source", 0);
              } else {
                this.$message.warning(rst.msg);
              }
            })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    deletecourse(Id) {
      this.delCourseWare(this.courseWare.Id);
    },

    handleSelectionChange(Id) {
      if (!this.checkedList[Id]) {
        this.checkedList[Id] = false;
        var index = this.dataList.indexOf(Id);
        this.dataList.splice(index, 1);
      } else {
        this.checkedList[Id] = true;
        this.dataList.push(Id);
      }
    },

    // 批量移动
    MoveFolder() {
      this.$http.post('/api/XOrg/BookMaterial/moveFolder',{
        ids: this.dataList,
        fId: this.fId
      }).then( rst => {
        if (rst.code > 0) {
          this.rdialogVisible = false;
          this.$message.success(rst.msg);
          this.source[0].list = "";
          this.getSourceList(this.source[0].pageIndex, "source", 0);
          this.dataList = [];
          this.fId = "";
        } else {
          this.$message({
            type: "warning",
            message: rst.msg
          });
        }
      })
    },
    // 移动取消
    cancelMoveFolde: function() {
      this.getSourceList(this.source[0].pageIndex, "source", 0);
      this.rdialogVisible = false;
      for (let i = 0; i < this.source[0].list.length; i++) {
        if (this.source[0].list[i].checked == true) {
          this.source[0].list[i].checked = false;
        }
      }
      this.dataList = [];
    },
    handleCloseSourceSort: function(){
      this.getSourceList(this.source[0].pageIndex, "source", 0);
      this.sortdialogVisible = false;
    },
    handleCloseSource: function() {
      this.getSourceList(this.source[0].pageIndex, "source", 0);
      this.rdialogVisible = false;
      for (let i = 0; i < this.source[0].list.length; i++) {
        if (this.source[0].list[i].checked) {
          this.source[0].list[i].checked = false;
        }
      }
      this.dataList = [];
    },
    DelallCourseWare() {
      let self = this;
      if (this.dataList.length == 0) {
        this.$message.warning("请选择课件");
      }
      if (this.dataList.length > 0) {
        this.$confirm("此操作将删除该课件, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            let pageIndex = self.source[0].pageIndex;
            if(self.dataList.length == self.source[0].list.length){
              // pageIndex = pageIndex - 1;
              self.source[0].pageIndex = self.source[0].pageIndex - 1;
            }
            this.$http.post('/api/XOrg/BookMaterial/delallCourseWare',{
              ids: self.dataList
            }).then( rst => {
              if (rst.code > 0) {
                self.$message.success(rst.msg);
                self.source[0].list = "";
                self.getSourceList(self.source[0].pageIndex, "source", 0);
                self.dataList = []
              } else {
                self.$message({
                  type: "warning",
                  message: rst.msg
                });
              }
            })
          })
          .catch(() => {
            self.$message({
              type: "info",
              message: "已取消删除"
            });
            self.getSourceList(self.source[0].pageIndex, "source", 0);
            for (let i = 0; i < self.source[0].list.length; i++) {
              if (self.source[0].list[i].checked) {
                self.source[0].list[i].checked = false;
              }
            }
          });
      }
    },

    changeMenu: function() {
      this.menuShow = !this.menuShow;
    },
    move() {
      if (this.dataList.length == 0) {
        this.$message.warning("请选择文件");
      } else {
        this.rdialogVisible = true;
        this.GetFolderId();
        this.$http.post('/api/XOrg/BookMaterial/getsourcelist',{
          courseId: this.courseId,
          folderId: this.folderId,
          type: this.activeName,
          sort: 1,
        }).then( rst => {
          rst.nodePathList.forEach(element => {
              this.pathdata.push({ label: element.nodeName, id: element.Id });
            });
        })
      }
    },

    handleNodeClick(data) {
      this.fId = data.id;
    },

    GetFolderId() {
      this.$http.post('/api/XOrg/BookMaterial/getFolderId',{
        courseId: this.courseId
      }).then( rst => {
        let folder = {};
        let resultFolder = [];
        if (rst.list && rst.list.length) {
          folder = {};
          rst.list.forEach(el => {
            // el.NodePath
            if (el.ParentId === '0') {
              folder[el.Id] = folder[el.Id] || {
                id: el.Id,
                children: []
              };
              folder[el.Id]['label'] = el.FolderName;
              resultFolder.push(folder[el.Id]);
            } else {
              if (el.NodePath && el.NodePath.length) {
                let paths = el.NodePath.split('/');
                let pathsLen = paths.length - 1;
                for (let i = 0; i <= pathsLen; i++) {
                  let path = paths[i];

                  if (i !== pathsLen) {
                    folder[path] = folder[path] || {
                      id: path,
                      children: []
                    };
                  } else {
                    folder[path] = folder[path] || {
                      id: el.Id
                    };
                    folder[path]['label'] = el.FolderName;

                    let parent = folder[el.ParentId];
                    if (parent && !parent.children) {
                      parent['children'] = [];
                    }
                    folder[el.ParentId].children.push(folder[path]);
                  }
                  folder[el.ParentId] = folder[el.ParentId] || {
                    id: el.ParentId,
                    children: []
                  };
                }
              }
            }
          });
        }
        console.log(resultFolder);
        this.nodeTree = [
          {
            label: "根目录",
            id: "0",
            children: [...resultFolder]
          }
        ];
      })
    },

    AddLabels() {
      let word = this.keyword.join(",");
      this.$http.post('/api/XOrg/BookMaterial/addLabels',{
        id: this.sourceId,
        keyword: word,
        mediaType: this.mediaType,
        language: this.language,
        sourceone: this.sourceone,
        author: this.author,
        company: this.company,
        contactInformation: this.contactInformation
      }).then( rst => {
        if (rst.code > 0) {
          this.$message.success(rst.msg);
          this.getSourceList(this.source[0].pageIndex, "source", 0);
          this.end();
        } else {
          this.$message.warning(rst.msg);
        }
      })
    },

    GetMediaType(doex) {
      if (doex == ".mp3") {
        return 1;
      } else if (doex == ".mp4") {
        return 2;
      } else if (
        doex == ".doc" ||
        doex == ".docx" ||
        doex == ".pdf" ||
        doex == ".xlsx" ||
        doex == ".xls" ||
        doex == ".txt"
      ) {
        return 3;
      } else if (doex == ".ppt" || doex == ".pptx") {
        return 4;
      } else if (doex == ".zip" || doex == ".rar") {
        return 5;
      } else if (doex == ".ziph") {
        return 6;
      } else if (
        doex == ".jpg" ||
        doex == ".png" ||
        doex == ".jpeg" ||
        doex == ".svg" ||
        doex == ".ico" ||
        doex == ".gif" ||
        doex == ".hdr"
      ) {
        return 7;
      } else if (doex == ".swf") {
        return 8;
      } else if (doex == ".com") {
        return 9;
      } else {
        return "";
      }
    },
    importSource() {
      if (this.sourceids.length == 0) {
        this.$message.warning("请选择课件！");
      } else {
        this.$http.post('/api/XOrg/PartnerShareSource/AddCourseScourse',{
          ids: this.sourceids,
          courseId: this.courseId,
          folderId: this.folderId
        }).then( rst => {
          if (rst.code > 0) {
            this.$message.success(rst.msg);
          } else {
            this.$message({
              type: "warning",
              message: rst.msg
            });
          }
          let checkLength = this.list.length;
          for (let i = 0; i < checkLength; i++) {
            if (this.list[i].checked) {
              if (this.list[i].checked == true) {
                this.list[i].checked = false;
              }
            }
          }
          this.sourceids = [];
          this.source[0].pageIndex = 1;
          this.ThirePartydialogVisible = false;
          this.getSourceList(1, "source", 0);
        });
      }
      this.disabled = false;
      this.checkStatus = true;
      this.isChoice = "007";
    }
  }
});

// interface IDropdownCommand {
//   type: string;
//   data: {
//     Id: string;
//     CourseWareName: string;
//     CourseWareType: number;
//   };
// }
</script>

<style lang="scss">
.yk-source-new-wrapper-courseware {
  position: relative;
  .yk-course__control{
    padding: 0;
    border: none;
    background: #f2f6f9;
  }
  .upload-video-explain {
    position: absolute;
    top: 20px;
    left: 25px;
    color: #fdb939;
    font-size: 17px;
    z-index: 2000;
  }
  .yk-btn-new-back-s-1 {
    position: fixed;
    right: 53px;
    top: 10px;
    z-index: 2000;
    padding: 2px 10px;
    .wl-icon-fanhui2 {
      font-size: 29px;
    }
  }
  .yk-course-ware-el-card {
    float: left;
    margin-left: 20px;
  }
  .lectures-wrapper-new-s-1-1 {
    .el-dropdown {
      margin-top: 10px;
      .create-folder {
        .el-button {
          background: #fff;
          color: black;
          border: none;
        }
      }
    }
    .el-dropdown-link:focus {
      outline: none;
    }
    .add-c-title {
      margin-top: 10px;
      font-size: 20px;
      text-align: center;
    }
    .wl-icon-tianjia1 {
      font-size: 100px;
      color: #fff;
      border-radius: 50%;
      border: 2px solid #fff;
      margin-left: 22px;
    }
  }
  .video-wrapper {
    height: 50%;
    width: 100%;
    position: relative;
    text-align: center;
    .video-player {
      height: 100% !important;
    }
    .vjs-big-play-button {
      border-radius: 50% !important;
      height: 70px !important;
      width: 70px !important;
      margin-left: -35px;
    }
    .vjs-poster {
      background-size: 100% !important;
    }
    .video-js {
      height: 100% !important;
    }
    .video-poster {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 1000;
      background-color: rgba(0, 0, 0, 0.4);
    }
    video {
      width: 100%;
      height: 100%;
      object-fit: fill;
    }
  }
  .el-dialog__footer {
    border: 1px solid #f2f6f9;
  }
}
.yk-source {
  .yk-batch-delete {
    .yk-sourse-nemu-btn-wrapper {
      float: right;
      margin-left: 10px;
      width: 90px;
      height: 32px;
      background: rgba(63, 162, 255, 1);
      border-radius: 3px;
      line-height: 32px;
      text-align: center;
      color: #fff;
      .el-dropdown-link {
        font-size: 11px;
      }
    }
  }
  .yl-last-source-tab-head-wrapper {
    .el-tabs__nav-wrap::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 1px !important;
      background-color: #fff;
      z-index: 1;
    }
    .el-tabs__nav {
      padding: 10px 0 10px 50px;
    }
    .el-tabs__item {
      font-size: 18px;
      color: #fff;
    }
    .el-tabs__active-bar {
      display: none;
    }
    .el-tabs__content {
      padding: 0 30px;
    }
    .el-pagination__total {
      margin-right: 10px;
      font-weight: 400;
      color: #fff;
    }
    .el-pagination__jump {
      margin-left: 24px;
      font-weight: 400;
      color: #fff;
    }
    .el-pagination {
      position: unset !important;
    }
  }
}
.PreviewResourcces {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2010;
  background-color: rgba(0, 0, 0, 0.9);
  width: 100%;
  height: 100%;
  overflow: auto;
  .icon-closeimg-s {
    size: 26px;
    position: fixed;
    right: 20px;
    font-size: 35px;
    cursor: pointer;
    font-weight: bolder;
    bottom: 20px;
  }
}
.xiazai {
  margin-right: 10px;
  text-decoration: none;
  font-weight: bold;
  font-size: 18px;
  color: #606266;
  float: right;
  .icon-closeimg-s {
    size: 26px;
    position: fixed;
    right: 20px;
    font-size: 35px;
    cursor: pointer;
    font-weight: bolder;
    bottom: 20px;
  }
}

/*样式已经移到themes/default/components/courseware.scss里*/
.yk-source-new-wrapper {
  .el-tabs {
    margin-top: 20px;
  }
  .el-tabs__content {
    // padding: 0 40px;
  }
  .el-tabs__active-bar {
    background-color: #374256;
  }
  .el-tabs__nav-scroll {
    padding-left: 45px;
    height: 50px;
  }
  #tab-source {
    color: #fff;
    font-size: 18px;
    font-weight: 400;
    font-weight: bold;
  }
  .el-tabs__nav-wrap:after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    background-color: #505e75;
    z-index: 1;
  }
}
.dark {
  .el-dropdown-menu {
    .el-dropdown-menu__item {
      .create-folder,
      .oss-upload_source,
      .aliyun-oss {
        .el-button {
          color: #000000;
          background-color: inherit;
          border: none;
          font-size: 14px;
          .el-icon-upload,
          .wl-icon-lianjie {
            color: #409eff;
          }
        }
      }

      &:hover {
        .create-folder,
        .oss-upload_source,
        .aliyun-oss {
          .el-button {
            color: #409eff;
          }
        }
      }
    }
  }
}
// .light {
  .yk-source{
    .el-tabs .el-tabs__content .el-tab-pane .yk-source-container .el-card{
      background-color: #edf2f6;
      margin: 5px 10px;
      -webkit-box-shadow: 0 2px 5px 0 rgba(0,0,0,.24);
      box-shadow: 0 2px 5px 0 rgba(0,0,0,.24);
      border-radius: 10px;
      position: relative;
      color: #000;
      border-color: #edf2f6;
      box-sizing: border-box;
      .yk-checkBox{
        .el-checkbox__inner{
          background-color: #fff;
        }
      }
      .el-checkbox__inner::after{
        border-color: #409eff;
      }
      .yk-source-intro{
        .yk-info-footer{
          .yk-operate-btns{
            .yk-course__control{
              .wl-icon-i-more{
                color: #000;
                background-color: #edf2f6;
              }
            } 
          } 
        } 
      }  
    }
    .yl-last-source-tab-head-wrapper{
      .el-pagination__jump{
        color: #000;
      }
      .el-pagination__total{
        color: #000;
      }
    } 
  }

  .yk-source-new-wrapper-courseware{
    .lectures-wrapper-new-s-1-1{
      .wl-icon-tianjia1 {
        height: 100px;
        font-size: 100px;
        color: #000;
        border-radius: 50%;
        border: 2px solid #000;
        margin-left: 22px;
        display: inline-block;
      }
      .add-c-title {
        margin-top: 10px;
        font-size: 20px;
        text-align: center;
        color: #000;
      }
    } 
  } 
  .change-search-in-wrapper{
    .el-input__inner{
      color: #000;
      border-color: #edf2f6;
      background-color: #fff;
    }
  }
  .el-dropdown-menu{
    .el-dropdown-menu__item{
      .oss-upload_source{
        .el-button{
          color: #000;
          background-color: inherit;
          border: none;
          font-size: 14px;
        }
      }
    }   
  }
  .yk-class-button{
    .wl-icon-lianjie{
      color: rgb(64, 158, 255);
    }
    .el-button{
      color: #000;
      background-color: inherit;
      border: none;
      font-size: 14px;
    }
  }
// }
</style>
